export default "__VITE_ASSET__CsUq2aB4__"